import $ from 'jquery';

class AjaxHandler {
    constructor() {
        this.init();
    }

    init() {
        $(function() {
            $('.category-btn').on('click', function(e) {
                e.preventDefault();
        
                $('.category-btn').removeClass('active');
                $(this).addClass('active');
        
                var categorySlug = $(this).data('category');
        
                $.ajax({
                    url: ajax_object.ajax_url,  // '/wp-admin/admin-ajax.php',
                    type: 'POST',
                    data: {
                        action: 'my_custom_filter',
                        category_slug : categorySlug,
                    },
                    success:function(response) {
                        // Parse the JSON response
                        var posts = JSON.parse(response);
        
                        // Clear out the current posts on your page...
                        
                        // Loop through each post and add it to your page...
                        
                    },
                    error:function(errorThrown){
                        console.log(errorThrown);
                    }
                });
            });
        });
    }
}

export default AjaxHandler;
